import type { LabelHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.ts';

/** Label über dem Feld in Meta-Größe, Text 2; optional graues Wort „Pflicht“. */
export function Label({
  className,
  required,
  children,
  ...props
}: LabelHTMLAttributes<HTMLLabelElement> & { required?: boolean }) {
  return (
    <label className={cn('type-meta mb-space-2 block text-ink-2', className)} {...props}>
      {children}
      {required ? <span className="ml-space-2 text-ink-3">Pflicht</span> : null}
    </label>
  );
}
